import { useState } from "react";

import "../css/Sidebar.css";

const Button = ({title, icon, onClick}) => {
    const [showTip, setShowTip]  = useState(false);

    return <button 
        onMouseEnter={() => setShowTip(true)}
        onMouseLeave={() => setShowTip(false)}
        onClick={onClick}
        className="sidebar-button"
    >
        <a title={title} className={icon}></a>
        {showTip ? <span data-status="show">{title}</span> : <span data-status="hidden">{title}</span> }
    </button>
}

//<Button icon="fa-regular fa-user" title="Profile"/>
const Sidebar = () => {
    return <div className="sidebar">
        <Button icon="fa-solid fa-ticket" onClick={() => window.location = '/v2/staff/tickets'} title="Tickets"/>
        <Button icon="fa-solid fa-book" onClick={() => window.location = '/v2/staff/archive/tickets'} title="Archives"/>
    </div>
}

export default Sidebar;